<template>
  <div class="service-container" :class="{active:!loading}">
    <div class="content">
      <div class="three digital">
        <img :src="resources['servicesThree'].src" alt="">
        <div class="line-group">
          <div class="icon-plus"></div>
          <div class="line-top"></div>
          <div class="line-bottom"></div>
        </div>
      </div>
      <div class="six digital">
        <img :src="resources['servicesSix'].src" alt="">
        <swiper :options="swiperOption2" class="custom-swiper">


          <swiper-slide class="custom-swiper-slide" v-for="(slider,index) in sliders" :key="index">
            <div class="slide-box">
              <img 
              v-for="(text ,order) in slider.texts" 
              :key="order"
              :style="{width:text.width}"
              :data-swiper-parallax="-100 * (order + 1)" :src="text.src"/>
            </div>
          </swiper-slide>

        </swiper>
      </div>
      <div class="zero digital">
        <img :src="resources['servicesZero'].src" alt="">
        <swiper :options="swiperOption" class="custom-swiper">
          <swiper-slide class="custom-swiper-slide" v-for="(slider,index) in sliders" :key="index">
            <img :style="{width:slider.icon.width}" :src="slider.icon.src"/>
          </swiper-slide>
          
        </swiper>

        <div class="line-group">
          <div class="icon-plus"></div>
          <div class="line-top"></div>
          <div class="line-bottom"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {swiper , swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'

const SWIPEROPTIONS = {
  loop:true,
  speed:1000,
  noSwiping:true,
  noSwipingClass:'custom-swiper-slide',
  autoplay:{
    duration: 5000,
    stopOnLastSlide: false,
    disableOnInteraction:true
  }
};

export default {
  data(){
    return {
      swiperOption2:{...SWIPEROPTIONS,parallax:true},
      swiperOption:{...SWIPEROPTIONS},
      resources:null,
      loading:true,
      sliders:[]
    }
  },
  created(){
    this.remFix();
    let resources = this.resources = this.$store.state.resources;
    function px2rem($val = 0 , $base = 100){
      return ( $val / $base ) + 'rem';
    }
    let arr  = [
      {
        icon: 145,
        text: [119,182,179]
      },
      {
        icon: 161,
        text: [155,164,161]
      },
      {
        icon: 180,
        text: [149,133,136]
      },
      {
        icon: 175,
        text: [117,162]
      },
      {
        icon: 185,
        text: [118,160,161]
      },
      {
        icon: 186,
        text: [118,164,163]
      },
      {
        icon: 174,
        text: [117,158,156]
      },
      {
        icon: 178,
        text: [117,158,156]
      }
    ]
    for(var i = 1 ; i <= 8;i++){
      let tempObj = {} , size = arr[i-1];
      tempObj.icon =  { 
        src: resources[`serviceSwiper${i}Pic`].src,
        width: px2rem(size.icon)
      };
      tempObj.texts =[];
      for(var j = 1 ; j <= 3 ; j++){
        let _size = size.text[j-1];
        if(_size) {

          let obj = {
            src:  resources[`serviceSwiper${i}Desc${j}`].src,
            width:px2rem(_size)
          }
          tempObj.texts.push(obj)

        }
      }

      this.sliders.push(tempObj);
    }
   
  },
  components:{
    swiper,
    swiperSlide
  },
  mounted(){
    this.loading = false;
  },
  beforeRouteLeave (to, from, next) {
    this.loading = true;
    next();
  }
}
</script>
<style lang="scss" scoped>
@import "../common/common.scss";
  .content {
    display: flex;
    position: absolute;
    left: px2rem(555);
    top: 50%;
    transform: translate3d(0,-50%,0);
  }

  .line-group {
    position: absolute;
    width: px2rem(476);
    height: px2rem(30);
    
    box-sizing: border-box;
    .line-top,
    .line-bottom {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      transform: scaleX(0);
    }
    .line-top{
      border-top: px2rem(2) solid #ee0a07;
      top: 0;
    }
    .line-bottom {
      border-bottom: px2rem(2) dashed #ee0a07;
      bottom: 0;
    }
    &:after {
      position: absolute;
      width: 100%;
      content: "";
      border-top: px2rem(2) solid #ee0a07;
      top: 0;
      transform: scaleX(0);
    }
  }


  .digital {
    position: relative;
    > img {
      width: 100%;
    }
    + .digital {
      margin-left: px2rem(22);
    }
    &.three{
      width:px2rem(220);
      height: px2rem(383);
      position: relative;
      > img {
        width: 100%;
        height: 100%;
        transform: translate(0,100%);
        opacity: 0;
      }
      &:after {
        content: '';
        position: absolute;
        left: px2rem(201);
        top: px2rem(210);
        width: px2rem(272);
        border-top: px2rem(2) dashed #ee0a07;
        transform-origin: left center;
        transform: rotateZ(-52deg) scaleX(0) ;
        
      }
      
      .icon-plus {
        position: absolute;
        left: px2rem(-19);
      }

      .line-group {
        left: px2rem(-438);
        top: 0;
        .line-top {
          transform-origin: left center;
        }
        .line-bottom {
          transform-origin: right center;
        }
        &:after {
          right: px2rem(514);
          transform-origin: center right;
        }
      }
      
    }
    &.six {
      width:px2rem(289);
      height: px2rem(392);
      transform: translate3d(0,-100%,0);
      opacity: 0;
      > img{
         width: 100%;
        height: 100%;
      }
    }
    &.zero {
      width:px2rem(395);
      height: px2rem(394);
      position: relative;
      transform: translate3d(0,100%,0);
      opacity: 0;
      > img{
         width: 100%;
        height: 100%;
      }
      .line-group {
        left: 50%;
        top: px2rem(392);
        .line-top {
          transform-origin: right center;
        }
        .line-bottom {
          transform-origin: left center;
        }
        &:after {
          left: px2rem(514);
          transform-origin: left center;
        }
      }
      .icon-plus {
        position: absolute;
        right: px2rem(-19);
      }
    }
  }
  
  .custom-swiper {
    border-radius: 50%;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 0;
    overflow: hidden;
    .custom-swiper-slide {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .slide-box {
      display: inline;
      flex-grow: 0;
      flex-shrink: 0;
    }
    img {
      display: block;
      + img {
        margin-top: px2rem(6);
      }
    }
  }
  .six {
    .custom-swiper {
      width: px2rem(226);
      height: px2rem(226);
      bottom: px2rem(31);
    }
  }
  .zero {
    .custom-swiper {
      width:  px2rem(334);
      height:  px2rem(334);
      bottom:  px2rem(30);
    }
  }
  .icon-plus {
    width: 0;
    height: 0;
    position: absolute;
    transform:scale(0);
    $width : px2rem(20);
    $height: px2rem(2);
    &:after,
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
      background: #ee0a07;
    }
    &:after {
      width: $width;
      height: $height;
    }
    &:before {
      width: $height;
      height: $width;
    }
  }

  .service-container.active {
    .three {
      > img {
        transform: none;
        opacity: 1;
        transition: all .5s linear;
      }
    }
    .six{
      transform: none;
      opacity: 1;
      transition: all .5s .2s linear;
    }
    .zero {
      transform: none;
      opacity: 1;
      transition: all .5s .5s linear;
    }

    .icon-plus {
      animation: icon_anim .9s 1s forwards;
    }
    .line-top,
    .line-bottom {
      transform: none;
      transition: all .5s 1s linear;
    }
    .line-group:after {
      transform: none;
      transition: all .5s 1s linear;
    }
    .three:after {
      transform: rotateZ(-52deg) scaleX(1) ;
      transition: all .5s 1s linear;
    }
  }

  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
</style>
